<template>
  <Section v-if="currentGallery">
    <template v-slot:section-body>
      <div class="row">
        <div class="col-md-8 currentGallery-form">
          <FormGroup>
            <h5 class="name">ชื่อ</h5>
            <input
              type="text"
              class="form-control"
              v-model="title" />
          </FormGroup>
          <FormGroup>
            <h5 class="name">คำอธิบาย</h5>
            <textarea
              type="text"
              class="form-control"
              v-model="description">
            </textarea>
          </FormGroup>
        </div>
        <div class="col-md-4">
          <ImageField
            :image.sync="currentGallery.coverImage" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <FormGroup>
            <h5 class="name">รายการรูปภาพ</h5>
            <GalleryImageUploader />
          </FormGroup>
        </div>
      </div>
    </template>
  </Section>
</template>

<script>
import { mapGetters } from 'vuex';
import Section from '@/components/Section.vue';
import FormGroup from '@/components/FormGroup.vue';
import ImageField from '@/image/ImageField.vue';

import GalleryImageUploader from './GalleryImageUploader.vue';

export default {
  components: {
    Section,
    FormGroup,
    ImageField,
    GalleryImageUploader,
  },
  computed: {
    ...mapGetters([
      'currentGallery',
      'currentGalleryWasEdited',
    ]),
    title: {
      get() {
        return this.$store.state.gallery.currentGallery.title;
      },
      set(value) {
        this.$store.commit('updateGalleryTitle', value);
      },
    },
    description: {
      get() {
        return this.$store.state.gallery.currentGallery.description;
      },
      set(value) {
        this.$store.commit('updateGalleryDescription', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';

.currentGallery-form {
  margin-top: 10px;
}

textarea {
  min-height: 110px;
}

.modal-content {
  .page-header {
    display: flex;
    flex-flow: row;
    width: 100%;
    align-items: center;
    padding: 20px 32px 0;
    justify-content: space-between;

    h1 {
      font-size: 20px;

      i {
        cursor: pointer;
      }
    }

    .actions {
      display: flex;
      flex-flow: row;
    }
  }
}
.alert-danger {
  max-height: 300px;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  h5.name {
    margin: 24px 0 12px;
  }
}
</style>
